import '@hotwired/turbo-rails'
import Sortable from 'sortablejs'

window.addEventListener('turbo:load', () => {
  const save = document.getElementById('save')
  const teamsContainer = document.getElementById('step-teams-container')

  // Helper functions for empty columns visibility
  const showEmptyColumns = () => {
    if (teamsContainer) {
      teamsContainer.classList.add('drag-active')
    }
  }

  const hideEmptyColumns = () => {
    if (teamsContainer) {
      teamsContainer.classList.remove('drag-active')
    }
  }

  const sectionsList = document.querySelectorAll('.sections-list')
  for (let i = 0; i < sectionsList.length; i++) {
    const sections = sectionsList[i]
    Sortable.create(sections, {
      animation: 150,
      group: 'sections',
      handle: '.cursor-grab',
      emptyInsertThreshold: 20,
      filter: function (evt) {
        // Don't drag section if clicking on an item's handle
        const clickedHandle = evt.target.closest('.cursor-grab')
        if (clickedHandle && clickedHandle.closest('li')) {
          return true // Filter out (don't drag)
        }
        return false
      },
      onStart: () => {
        showEmptyColumns()
      },
      onEnd: (event) => {
        hideEmptyColumns()
        save.classList.remove('opacity-0')
        const teamId = event.item.closest('.team').dataset.teamId
        const teamInput = event.item.querySelector("input[id*='team_id']")
        console.log('update team_id', teamId)
        teamInput.value = teamId
        Array.from(event.to.children).forEach((section, index) => {
          const input = section.querySelector("input[id*='position']")
          if (input) {
            input.value = index + 1
          }
        })
        Array.from(event.from.children).forEach((section, index) => {
          const input = section.querySelector("input[id*='position']")
          if (input) {
            input.value = index + 1
          }
        })

        // Update empty status for source and target teams
        const fromTeam = event.from.closest('.team')
        const toTeam = event.to.closest('.team')

        // Check if source team is now empty
        if (fromTeam && event.from.children.length === 0) {
          fromTeam.classList.add('team-empty')
        }

        // Target team is no longer empty
        if (toTeam && event.to.children.length > 0) {
          toTeam.classList.remove('team-empty')
        }
      }
    })
  }

  const items = document.querySelectorAll('.items-list')
  for (let i = 0; i < items.length; i++) {
    const item = items[i]
    Sortable.create(item, {
      animation: 150,
      group: 'items',
      handle: '.cursor-grab',
      swapThreshold: 0.65,
      onStart: () => {
        // Don't show empty columns when dragging items
      },
      onEnd: (event) => {
        save.classList.remove('opacity-0')
        const sectionId = event.item.closest('.section').dataset.sectionId
        const teamInput = event.item.querySelector("input[id*='section_id']")
        teamInput.value = sectionId
        Array.from(event.to.children).forEach((section, index) => {
          const input = section.querySelector("input[id*='position']")
          if (input) {
            input.value = index + 1
          }
        })
        Array.from(event.from.children).forEach((section, index) => {
          const input = section.querySelector("input[id*='position']")
          if (input) {
            input.value = index + 1
          }
        })
      }
    })
  }
  if (save) {
    save.addEventListener('click', () => {
      const sections = document.querySelectorAll('.sections-list')
      for (let i = 0; i < sections.length; i++) {
        const section = sections[i]
        const items = section.children
        let j = 1
        for (let i = 0; i < items.length; i++) {
          const input = items[i].querySelector("input[id*='position']")
          if (input) {
            input.value = j
            j += 1
          }
        }
      }
    })
  }
})
